module.exports = __webpack_public_path__ + "static/media/object.3aafbf2b.png";